import axios from "axios";
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MyApi } from "./MyApi";

export default function Footer() {
  const [showTopBtn, setShowTopBtn] = useState(false);
  const [setting, setSetting] = useState(null);
  const [loading, setLoading] = useState(true);

  /* Scroll to top button */
  useEffect(() => {
    const handleScroll = () => setShowTopBtn(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* Fetch site settings */
  useEffect(() => {
    const fetchSetting = async () => {
      try {
        const res = await axios.get(
          MyApi.BASE_URL + "site-setting",
          {
            headers: { Authorization: MyApi.SECRET_KEY },
          }
        );

        if (res.data?.status && res.data?.data) {
          setSetting(res.data.data);
        }
      } catch (error) {
        console.error("Failed to load site settings", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSetting();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading) return null; // prevent crash while loading

  return (
    <div className="footer_bx">
      <Container>
        <Row>
          {/* Quick Links */}
          <Col lg={5} className="mb-4">
            <h4>Quick Links</h4>
            <Row>
              <Col lg={6} xs={6}>
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/about-us">About Us</Link></li>
                  <li><Link to="/our-cars">Our Cars</Link></li>
                  <li><Link to="/photo-gallery">Photo Gallery</Link></li>
                  <li><Link to="/faq">FAQs</Link></li>
                  <li><Link to="/contact-us">Contact Us</Link></li>
                </ul>
              </Col>

              <Col lg={6} xs={6}>
                <ul>
                  <li><Link to="/video-gallery">Video Gallery</Link></li>
                  <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                  <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
                  <li><Link to="/certifications">Certifications</Link></li>
                  <li><Link to="/blog">Blog</Link></li>
                </ul>
              </Col>
            </Row>
          </Col>

          {/* Contact */}
          <Col lg={4} className="mb-4">
            <h4>Contact</h4>

            {setting?.address && <p className="m-0 p-0 pb-2"><strong>Address: </strong>  {setting.address}</p>}

            {setting?.emailid && (
              <p className="m-0 p-0 pb-2"><strong>Email Id: </strong>
                <a href={`mailto:${setting.emailid}`}>
                  {setting.emailid}
                </a>
              </p>
            )}

            {setting?.mobile && (
              <p ><strong>Phone: </strong>
                <a href={`tel:${setting.mobile}`}>
                  {setting.mobile}
                </a>
              </p>
            )}

            <h4 className="mb-2">Lucknow Office</h4>
            <p><strong>Phone: </strong> <a href="tel:+91 7275482660">+91 7275482660</a> <br/> 
            <strong>Address: </strong> 
9/46, Saraswati Puram,
Khargapur, Gomti Nagar,
Lucknow, Uttar Pradesh – 226010</p>
          </Col>

          {/* Social */}
          <Col lg={3} className="mb-4">
            <h4>Follow us on</h4>
            <div className="social-icons">

              {setting?.facebook && (
                <a href={setting.facebook} target="_blank" rel="noreferrer">
                  <i className="fa-brands fa-facebook-f"></i>
                </a>
              )}

              {setting?.youtube && (
                <a href={setting.youtube} target="_blank" rel="noreferrer">
                  <i className="fa-brands fa-youtube"></i>
                </a>
              )}

              {setting?.instagram && (
                <a href={setting.instagram} target="_blank" rel="noreferrer">
                  <i className="fa-brands fa-instagram"></i>
                </a>
              )}

              {setting?.linkedin && (
                <a href={setting.linkedin} target="_blank" rel="noreferrer">
                  <i className="fa-brands fa-linkedin-in"></i>
                </a>
              )}

            </div>
          </Col>
        </Row>
      </Container>

      {/* Copyright */}
      <div className="text-center footer_b">
        Copyright © {new Date().getFullYear()} Taxi Service Varanasi.
        All rights reserved.
      </div>

      {/* Back to Top */}
      {showTopBtn && (
        <button className="back-to-top" onClick={scrollToTop}>
          <i className="bi bi-arrow-up-short"></i>
        </button>
      )}
    </div>
  );
}